import React from "react";
import LeagueInvitationAcceptance from "../components/LeagueInvitation/LeagueInvitationAcceptance";

function LeagueInvitationAcceptancePage(){
    return(
        <LeagueInvitationAcceptance/>
    )
};

export default LeagueInvitationAcceptancePage;